import { render, staticRenderFns } from "./EventInfoModalAttractionList.vue?vue&type=template&id=8b0d3e4a&scoped=true&"
import script from "./EventInfoModalAttractionList.vue?vue&type=script&lang=js&"
export * from "./EventInfoModalAttractionList.vue?vue&type=script&lang=js&"
import style0 from "./EventInfoModalAttractionList.vue?vue&type=style&index=0&id=8b0d3e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d3e4a",
  null
  
)

export default component.exports